//
// class for DataFormatDecimalNanogramsPerMilliliter data type
//
// @extends [DataFormatterType]
//
import { DataFormatterOptions } from '../DataFormatterType';

import { DataFormatNumber } from './DataFormatNumber';

/**
 * Data formatter for DataFormatDecimalNanogramsPerMilliliter type.
 * @ignore
 */
export class DataFormatDecimalNanogramsPerMilliliter extends DataFormatNumber
{
    getName() : string
    {
        return "ecimalNanogramsPerMilliliter";
    }

    /* ecimalNanogramsPerMilliliter is stored internally as ng/mL */
    getUnitText(options ?: DataFormatterOptions) : string
    {
        return "ng/mL";
    }

}

export default DataFormatDecimalNanogramsPerMilliliter;
